export default "__VITE_ASSET__d070859b__"